var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"mt-16",on:{"click":_vm.generatePDF}},[_vm._v("Generate PDF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }